<template>
  <detail
    :onManager="onManager"
    :data="data"
    :base-info="baseInfo"
    :extra-info="extraInfo"
    status-module="modelarts"
    :hiddenKeys="['zone', 'region']"
    resource="modelarts_pools" />
</template>

<script>
import {
  getBrandTableColumn,
} from '@/utils/common/tableColumn'
import { sizestr } from '@/utils/utils'
import {
  getTrainingJobTableColumn,
  getInferenceServiceTableColumn,
  getDevelopEnvTableColumn,
  getNodeCountColumn,
} from '../utils/columns'

export default {
  name: 'ModelArtsDetail',
  props: {
    data: {
      type: Object,
      required: true,
    },
    onManager: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      sku: {},
      skuLoading: false,
      skuLoaded: false,
      baseInfo: [
        getTrainingJobTableColumn(),
        getInferenceServiceTableColumn(),
        getDevelopEnvTableColumn(),
        getBrandTableColumn(),
        getNodeCountColumn(),
      ],
      extraInfo: [
        {
          title: this.$t('ai.common.config'),
          items: [
            {
              field: 'cpu',
              title: 'CPU',
              slots: {
                default: () => {
                  if (this.skuLoading && !this.skuLoaded) {
                    return [<a-icon type='loading' style='font-size: 12px;' class='primary-color' />]
                  }
                  return [<span>{ this.sku.cpu_count }</span>]
                },
              },
            },
            {
              field: 'memory',
              title: this.$t('ai.common.memory'),
              slots: {
                default: () => {
                  if (this.skuLoading && !this.skuLoaded) {
                    return [<a-icon type='loading' style='font-size: 12px;' class='primary-color' />]
                  }
                  return [<span>{ sizestr(this.sku.memory, 'M', 1024) }</span>]
                },
              },
            },
          ],
        },
      ],
    }
  },
  created () {
    this.fetchSku()
  },
  methods: {
    async fetchSku () {
      try {
        this.skuLoading = true
        this.skuLoaded = false
        const response = await this.$http({
          method: 'GET',
          url: '/v2/modelarts_pool_skus',
          params: {
            scope: this.$store.getters.scope,
            filter: `name.contains('${this.data.instance_type}')`,
          },
        })
        this.sku = response.data.data[0]
        this.skuLoaded = true
      } finally {
        this.skuLoading = false
      }
    },
  },
}
</script>
